<div class="row">
  <div class="col-lg-3">
    <sb-card>
      <div card-body>
        <ul class="nav-tabs nav sidenav">
          <li class="nav-item">
            <a class="nav-link" [sbRouterLinkActive]="'active'" [isLinkActive]="util.RoutingID.channelDetailsOverview"
               [sbRouterLink]="util.RoutingID.channelDetailsOverview"><span><sb-icon class="mr-3"
                                                                                     icon="eye"></sb-icon>
              {{ 'lang.globals.overview' | translate }}</span></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [sbRouterLinkActive]="'active'" [isLinkActive]="util.RoutingID.channelDetailsMarker"
               [sbRouterLink]="util.RoutingID.channelDetailsMarker"><span><sb-icon class="mr-3" icon="screen"></sb-icon>
              {{ 'lang.globals.marker' | translate }}</span></a> <!-- fa-icon icon="chart-line"-->
          </li>
          <li class="nav-item" *ngIf="permissionService.hasPermission(permissionService.Permission.device_list) && channel?.locked">
            <a class="nav-link" [sbRouterLinkActive]="'active'" [isLinkActive]="util.RoutingID.channelDetailsDevices"
               [sbRouterLink]="util.RoutingID.channelDetailsDevices"><span><sb-icon class="mr-3"
                                                                                    icon="playerOnline"></sb-icon>
              {{ 'lang.globals.devices' | translate }}</span></a>
          </li>
        </ul>
      </div>
    </sb-card>
  </div>
  <div class="col-lg-9">
    <router-outlet></router-outlet>
  </div>
</div>
